import ShopServiceModel from '@/models/ShopServiceModel';
import SourceModel      from './SourceModel';
import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';

@model.urnResource('stonecode_file_type_source')
@doc.path('/stonecode_file_type_sources/{?id}')
export default class TypeSourceModel extends ShopServiceModel {
	private declare _tsFilters: {
		'locked': '0' | '1';
		'source': id;
		'source.entityUrn': id;
		'type': id;
		'type.deprecated': '0' | '1';
		// 'type.reference': FileTypeReference;
		'type.service': id;
		'type.service.serviceUrn': string;
		'type.system': '0' | '1';
	};

	private declare _tsSorts: {
		'id': string;
		'updatedAt': string;
	};

	@doc.boolean declare locked: boolean;
	@doc.model(SourceModel) declare source: SourceModel;
	// @doc.model(TypeModel) declare type: TypeModel;
}
